export const CONFIG = {
    backend_url : process.env.REACT_APP_BACKEND_URL,
    message_url : process.env.REACT_APP_MESSAGE_API_ENDPOINT,
    message_key : process.env.REACT_APP_SMS_KEY

}